<template>
	<div>
		<div class="footBox f-ct">
			<div class="conBox">
				
				<div class="detail f-bct">
					<div class="l flex">
						<el-image :src="require('@/static/icon17.png')"></el-image>
						<div class="txt">
							<p>主办单位：海南省燃气协会</p>
							<p>统一信用代码：51460000503861363H</p>
							<p>地址：海南省海口市龙华区金贸西路诚田国际商务大厦17层</p>
						</div>
						<div class="txt">
							<p>培训委：0898-68532902</p>
							<p>邮编：570000</p>
							<p>监督电话：0898-68532902</p>
						</div>
					</div>
					<div class="r flex">
						<div class="itm flex">
							<div class="txtBox">
								<p>扫码下载燃气协会APP</p>
								<p>让学习更高效</p>
							</div>
							<div class="imgBox">
								<el-image :src="require('@/static/downimg.png')"></el-image>
								<p>燃气协会APP</p>
							</div>
						</div>
						<div class="itm flex">
							<div class="txtBox">
								<p>扫码关注微信公众号</p>
								<p>及时了解最新培训</p>
								<p>注册动态信息</p>
							</div>
							<div class="imgBox">
								<el-image :src="require('@/static/downimg1.jpg')"></el-image>
							</div>
						</div>
					</div>
				</div>
				
				<div class="pageTxt f-ct" @click="getNewsDetail('https://beian.miit.gov.cn/')">
					<p>Copright @2017 Corporation AII Rights Reservde</p>
					<p>琼ICP备18003071号-2</p>
					<el-image :src="require('@/static/icon18.png')"></el-image>
					<p>琼公网安备46010802001165号</p>
					<p>海南省燃气协会网支持IPv6网络</p>
				</div>
				
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Foot",
	data(){
		return {
			
		}
	},
	mounted() {
		
	},
	methods:{
		
	}
}
</script>
<style lang="scss">
body{
	background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.footBox{
	width: 100%;
	height: 245px;
	background: #252E37;
	color: #fff;
	.conBox{
		width: 1560px;
		margin: auto;
		.detail{
			// padding-bottom: 24px;
			padding: 23px 0;
			.l{
				.el-image{
					width: 136px;
					height: 136px;
					margin-right: 32px;
				}
				.txt{
					font-size: 14px;
					color: #fff;
					padding-top: 29px;
					margin-right: 31px;
					p{
						margin-bottom: 8px;
					}
				}
			}
			.r{
				.itm{
					margin-right: 40px;
					.txtBox{
						padding-top: 29px;
						font-size: 14px;
						color: #fff;
						p{
							margin-bottom: 8px;
						}
					}
					.imgBox{
						padding-top: 19px;
						margin-left: 16px;
						.el-image{
							width: 108px;
							height: 108px;
							margin-bottom: 12px;
						}
						p{
							width: 108px;
							text-align: center;
							font-size: 14px;
							color: #fff;
						}
					}
				}
			}
		}
		.pageTxt{
			border-top: 1px solid #EEEEEE26;
			height: 36px;
			.el-image{
				width: 16px;
				height: 18px;
			}
			p{
				padding: 0 12px;
				font-size: 12px;
				color: #fff;
			}
		}
	}
}
</style>